import { CatalystSubcategories } from '@toggle/toggle';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import { usePosthogEvents } from '~/services/tracking/posthog/use-posthog-events/usePosthogEvents';

export type MarketCatalystDrawerParams = {
  type: CatalystSubcategories;
  themeId?: string;
  insightId: string;
  source: PosthogTrackingSource;
};

export const useMarketCatalystDrawer = () => {
  const { deleteQueryParam, setQueryParams, params } = useQueryParams();
  const { trackCatalystDrawerOpen } = usePosthogEvents();

  const openDrawer = (drawerParams: MarketCatalystDrawerParams) => {
    trackCatalystDrawerOpen(drawerParams.source, 'market');

    setQueryParams({
      [queryKeys.activeDrawer]: queryValues.marketCatalystDrawer,
      [queryKeys.type]: drawerParams.type,
      [queryKeys.themeId]: drawerParams.themeId,
      [queryKeys.insightId]: drawerParams.insightId,
    });
  };

  const closeDrawer = () =>
    deleteQueryParam([
      queryKeys.activeDrawer,
      queryKeys.type,
      queryKeys.themeId,
      queryKeys.insightId,
      queryKeys.utmSource,
      queryKeys.utmCampaign,
    ]);

  const isOpen = params.activeDrawer === queryValues.marketCatalystDrawer;

  return {
    closeDrawer,
    openDrawer,
    isOpen,
    drawerType: params[queryKeys.type],
    themeId: params[queryKeys.themeId],
    insightId: params[queryKeys.insightId],
    utmSource: params[queryKeys.utmSource],
  };
};
